module.exports = __webpack_public_path__ + "img/device-lock-auto.5ce677b4.svg";